/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentsListDeploymentsResponse = {
  result: components.V1DeploymentsListDeploymentsResponseBody;
};

/** @internal */
export const DeploymentsListDeploymentsResponse$inboundSchema: z.ZodType<
  DeploymentsListDeploymentsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Result: components.V1DeploymentsListDeploymentsResponseBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Result": "result",
  });
});

export function deploymentsListDeploymentsResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentsListDeploymentsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeploymentsListDeploymentsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentsListDeploymentsResponse' from JSON`,
  );
}
